var TeacherGuideElements = /* @__PURE__ */ ((TeacherGuideElements2) => {
  TeacherGuideElements2[TeacherGuideElements2["OBJECTIVES"] = 0] = "OBJECTIVES";
  TeacherGuideElements2[TeacherGuideElements2["FORMAL_OBJECTIVES"] = 1] = "FORMAL_OBJECTIVES";
  TeacherGuideElements2[TeacherGuideElements2["DESCRIPTION"] = 2] = "DESCRIPTION";
  return TeacherGuideElements2;
})(TeacherGuideElements || {});

export { TeacherGuideElements };
//# sourceMappingURL=request.get-teacher-guide.model.js.map
